import { useState, useEffect } from "react";
import {
  Box,
  Typography,
  Card,
  CardContent,
  Divider,
  CircularProgress
} from "@mui/material";
import mockData from "../../mocks/evaluaciones.json";

// Mapeo de puntajes numéricos a calificaciones cualitativas
const scoreToQualitativeMap = {
  5: "Excede ampliamente las expectativas",
  4: "Desempeño por encima del esperado",
  3: "Desempeño esperado",
  2: "Desempeño por debajo del esperado",
  1: "Bastante alejado del esperado"
};

export default function MyEvaluationsList() {
  const [evaluations, setEvaluations] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    // Simulamos una carga de datos
    const fetchEvaluations = async () => {
      try {
        // Simulamos un delay para ver el loading
        await new Promise(resolve => setTimeout(resolve, 1000));
        setEvaluations(mockData.evaluaciones);
      } catch (error) {
        console.error("❌ Error:", error);
        setError("No se pudieron cargar las evaluaciones");
      } finally {
        setLoading(false);
      }
    };

    fetchEvaluations();
  }, []);

  if (loading) {
    return (
      <Box display="flex" justifyContent="center" alignItems="center" minHeight="200px">
        <CircularProgress />
      </Box>
    );
  }

  if (error) {
    return (
      <Box p={4}>
        <Typography color="error">{error}</Typography>
      </Box>
    );
  }

  if (evaluations.length === 0) {
    return (
      <Box p={4}>
        <Typography>No hay evaluaciones disponibles.</Typography>
      </Box>
    );
  }

  return (
    <Box p={4} maxWidth="800px" mx="auto">
      <Typography variant="h4" mb={4}>
        Mis Evaluaciones
      </Typography>

      <Box display="flex" flexDirection="column" gap={3}>
        {evaluations.map((evaluation) => (
          <Card key={evaluation.id} variant="outlined">
            <CardContent>
              <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
                <Typography variant="h6" color="primary">
                  Período: {evaluation.period}
                </Typography>
                <Typography 
                  variant="subtitle1" 
                  sx={{
                    bgcolor: 'primary.50',
                    color: 'primary.main',
                    py: 0.5,
                    px: 2,
                    borderRadius: 1
                  }}
                >
                  {scoreToQualitativeMap[evaluation.score] || "No disponible"}
                </Typography>
              </Box>

              <Divider sx={{ my: 2 }} />

              <Box mb={3}>
                <Typography 
                  variant="subtitle1" 
                  fontWeight="bold" 
                  color="primary.dark"
                  gutterBottom
                >
                  Fortalezas
                </Typography>
                <Typography 
                  variant="body1" 
                  whiteSpace="pre-line"
                  sx={{ pl: 2 }}
                >
                  {evaluation.strengths}
                </Typography>
              </Box>

              <Box>
                <Typography 
                  variant="subtitle1" 
                  fontWeight="bold" 
                  color="primary.dark"
                  gutterBottom
                >
                  Áreas de Mejora
                </Typography>
                <Typography 
                  variant="body1" 
                  whiteSpace="pre-line"
                  sx={{ pl: 2 }}
                >
                  {evaluation.areasOfImprovement}
                </Typography>
              </Box>
            </CardContent>
          </Card>
        ))}
      </Box>
    </Box>
  );
} 